<template>
  <div class="table">
    <!-- <a-alert type="info" v-if="selectedRowKeys.length > 0" showIcon>
      <div class="info-slot" slot="message">
        <span>已选择{{selectedRowKeys.length}}条</span>
        <a-button type="link">取消</a-button>
        <a-button type="link">批量同步</a-button>
        <a-button type="link">批量操作</a-button>
      </div>
    </a-alert> -->

    <a-table
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      @change="pagChange"
      @expandRowByClick="true"
      :rowKey="record => record.id"
      :loading="loading"
    >
    <!-- 自定义基础信息 -->
    <template slot="name"  slot-scope="record">
      <p>{{record.name}}</p>
      <p>{{record.orgcode}}</p>
    </template>
    <!-- 自定义联系方式 -->
    <template slot="usermsg"  slot-scope="record">
      <p>{{record.contacts}}</p>
      <p>{{record.userPhones}}</p>
    </template>
    <!-- 自定义联系人 -->
    <template slot="userPhones" slot-scope="record" >
      <template v-if="record.phones">
        <p v-for="(item,index) in record.phones" :key="index">{{item}}</p>
      </template>
    </template>
    <!-- 自定义地区 -->
    <template slot="region" slot-scope="record" >
      <p v-if="record.region">{{record.region.label}}{{record.region.children[0].label}}</p>
      <span v-else>{{record.region}}</span>
    </template>
    <!-- 证书数量 -->
    <template slot="certNum" slot-scope="record" >
      <span v-if="record.certNum<=0">-</span>
      <span v-else>{{record.certNum}}</span>
    </template>
    <!-- 报告数量 -->
    <template slot="reportNum" slot-scope="record" >
      <span v-if="record.reportNum<=0">-</span>
      <span v-else>{{record.reportNum}}</span>
    </template>
    <!-- 自定义状态 -->
    <template slot="enable"  slot-scope="record">
        <span v-if="record.enable">邀请成功</span>
        <a-button v-else type="link" @click="handleCopy(record.invitation)" style="padding:0;margin-left: 10px">分享邀请码</a-button>
    </template>
    <template slot="operation"  slot-scope="record">
      <a-button type="link" v-if="roles.includes('USERDEPT_EDIT')" @click="editClient(record)" style="padding:0;">编辑</a-button>
      <a-button v-if="!record.enable && record.certNum ==0 && record.reportNum ==0 && roles.includes('USERDEPT_DELETE')" type="link" @click="itemDel(record.id,record.state)" style="padding:0;margin-left: 10px;">删除</a-button>
    </template>
    </a-table>
  </div>
</template>

<script>
const align = 'center'
const columns = [
  {
    title: "基本信息",
    scopedSlots: { customRender: 'name' },
    align
  },
  {
    title: "省市地区",
    // dataIndex: "region",
    scopedSlots: { customRender: 'region' },
    align
  },
  {
    title: "联系方式",
    scopedSlots: { customRender: 'usermsg' },
    align
  },
  {
    title: "证书数量(份)",
    scopedSlots: { customRender: 'certNum' },
    align
  },
   {
    title: "无证报告数量(份)",
    scopedSlots: { customRender: 'reportNum'},
    align
  },
  {
    title: "邀请码",
    dataIndex: "invitation",
    align
  },
  {
    title: "状态",
    scopedSlots: { customRender: 'enable'},
    align
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'operation' },
    align,
    width: 150,
    // fixed: 'right'
  }
];
export default {
  props:{
    tableData:Array
  },
  data() {
    return {
      // tableData:[],
      loading:false,
      columns,
      pagination: {
        showSizeChanger:true,
        pageSizeOptions: ['10', '50', '100', '200', '500'],
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
      cascaderOptions:[],
      copyData: '',
      roles: []
    };
  },
  mounted() {
    this.cascaderOptions = this.$province;
    let userMsg = this.$store.state.user.user;
    this.roles = userMsg.roles;

  },
  methods: {
    itemDel(id) {
      let that = this
      that.$confirm({
        title: '你确定要删除吗?',
        onOk() {
          that.$emit('delClient',id)
        },
        onCancel() {
        },
        class: 'test',
      });
    },
    editClient(record){
      let adds = []
      if(record.region){
        let province = record.region.value
        let city = record.region.children[0].value
        adds.push(province,city)
      }else{
        adds = []
      }
      let params =  {
        'name':record.name,
        'orgcode':record.orgcode,
        'id':record.id,
        'contacts':record.contacts,
        'userPhones':record.userPhones,
        'region':adds,
        'enable':record.enable,
        'certNum': record.certNum,
        'reportNum': record.reportNum
      }
      this.$emit('openEditClient',true,params);
      this.$emit('openEditClient',true,params);

    },
    pagChange(pagination,filters,sorter){
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.$emit("pagChange")
    },
    handleCopy(copyData){
      this.copyData = copyData;
      this.copyText(this.copyData);
    },
    copyText(text, callback){
        var tag = document.createElement('input');
        tag.setAttribute('id', 'cp_hgz_input');
        tag.value = text;
        document.getElementsByTagName('body')[0].appendChild(tag);
        document.getElementById('cp_hgz_input').select();
        document.execCommand('copy');
        this.$message.success('已复制，可以去邀请入驻了');
        document.getElementById('cp_hgz_input').remove();
    },
  }
};
</script>

<style lang="less" scoped>
.table {
  background-color: #fff;
  .ant-alert-info {
    padding: 3px 15px 3px 37px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;

    /deep/.ant-alert-icon {top: auto !important;}

    .info-slot {
      display: flex;
      align-items: center;

      .ant-btn {padding-right: 0px;}
    }
  }
}
</style>
